var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "popupContainer",
      attrs: {
        visible: true,
        fullscreen: true,
        "modal-append-to-body": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
        title: "关于我们",
        center: true,
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "main-container as-full-width as-full-height as-flex flex-vertical main-center cross-center",
        },
        [
          _c("img", {
            staticClass: "img",
            attrs: { src: require("../../assets/images/login-logo.png") },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "f-2 fc-gray-2" }, [
            _vm._v("凡影旗下敏捷调研数据平台"),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }